import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ReactiveFormsModule } from "@angular/forms";
import { CalendarModule } from "ion2-calendar";

import { IonicModule } from "@ionic/angular";

import { ProcedureSelectionModalPage } from "./procedureSelection-modal.page";

const routes: Routes = [
  {
    path: "",
    component: ProcedureSelectionModalPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    //CalendarModule
  ],
  declarations: [ProcedureSelectionModalPage],
})
export class ProcedureSelectionModalPageModule {}
